function heroCenteredManager() {
	this.heroElement = null;
	this.mediaWrapper = null;
	this.playButton = null;
	this.iframeParent = null;
	this.iframe = null;
	this.closeButton = null;

	this.setBottomColor = () => {
		const siblingClasses = this.heroElement.nextElementSibling.classList;
		const siblingBg = [...siblingClasses].find(className => className.startsWith('bg-')) || null;
		if (!this.mediaWrapper) return;
		this.mediaWrapper.classList.add(siblingBg);
	}

	this.collectElements = () => {
		this.heroElement = document.querySelector('.acf-block.block-hero-centered') || null;
		this.mediaWrapper = document.querySelector('.block-hero-centered__media-wrapper') || null;
		this.playButton = document.querySelector('.block-hero-centered__lightbox--play-button') || null;
		this.iframeParent = document.querySelector('.block-hero-centered__lightbox') || null;
		this.iframe = document.querySelector('.block-hero-centered__lightbox iframe') || null;
		this.closeButton = document.querySelector('.block-hero-centered__lightbox--close') || null;
	}

	this.showVideo = (e) => {
		if (e.target === this.playButton) {
			this.heroElement.classList.add('repositioned');
			this.iframeParent.classList.add('active');
			this.iframe.src = this.iframe.getAttribute('data-src');
			document.body.classList.add('lightbox-no-scroll');
		}
	}

	this.closeVideo = (e) => {
		if (e.target === this.closeButton) {
			this.heroElement.classList.remove('repositioned');
			this.iframeParent.classList.remove('active');
			this.iframe.src = '';
			document.body.classList.remove('lightbox-no-scroll');
		}
	}

	this.init = () => {
		this.collectElements();
		if (!this.heroElement) return;
		this.setBottomColor();
	}

	return this;
}

const heroCentered = new heroCenteredManager();

// GLOBAL APP CONTROLLER
const controller = {
	init() {
		heroCentered.init();
	},
	loaded() {},
	resized() {},
	scrolled() {},
	keyDown() {},
	mouseUp(e) {
		heroCentered.showVideo(e);
		heroCentered.closeVideo(e);
	},
};
export default controller;
